import React, { useContext } from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';

const NavbarExpandButton = ({ expandIconActive, onExpandIconClick }) => {
    const { setShowMobileApplicationSwitcher, setShowMobileNotifications, setShowMobileMenu } = useContext(NavbarContext);
    const handleNavbarExpandButtonClick = () => {
        onExpandIconClick && onExpandIconClick();
        setShowMobileApplicationSwitcher(false);
        setShowMobileNotifications(false);
        setShowMobileMenu(false);
    };
    return (React.createElement("button", { "aria-label": expandIconActive ? 'Collapse' : 'Expand', className: 'helix-unified-nav__nav-button helix-unified-nav__nav-button-drawer', onClick: () => handleNavbarExpandButtonClick() },
        React.createElement(NavbarHelixIcon, { iconName: expandIconActive ? 'close_drawer' : 'open_drawer' })));
};

export { NavbarExpandButton as default };
//# sourceMappingURL=NavbarExpandButton.js.map
